<section class="dts tsx" *ngIf="product as p" [class.tsx-single]="!groups.length"
         [style]="colorVars"
         [style.--tsx-wallpaper]="wallpaper"
         (pointerenter)="pointer( true )" (pointerleave)="pointer( false )"
         (focusin)="focus( true )" (focusout)="focus( false, $event )">
  <!-- a layer over the whole box from the page (the themes page's expander draws its popover edge) -->
  <ng-content select="[tsxOverlay]"></ng-content>
  <!-- the old theme banner's two logo halves in the box's corners (owner 2026-10-15), in the theme's first colour -->
  <svg class="box-logo box-logo-left" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 210 297">
    <defs>
      <!-- the theme's first colour, a touch lighter towards the box's middle -->
      <linearGradient [id]="'tsxLogoTopRight_' + p.key" x1="1" y1="0" x2="0" y2="1">
        <stop offset="0" style="stop-color: var(--plugin-primary, var(--theme-color))"/>
        <stop offset="1" style="stop-color: color-mix(in srgb, var(--plugin-primary, var(--theme-color)) 82%, #ffffff)"/>
      </linearGradient>
    </defs>
    <path [style.fill]="'url(#tsxLogoTopRight_' + p.key + ')'" d="m 178.50387,213.25342 c 14.21454,-12.55147 17.57518,-39.48208 6.87786,-55.13809 v 0 c -8.67477,-16.8641 -33.95747,-26.73174 -51.76202,-20.2132 v 0 L 79.25799,83.536554 162.79062,8e-5 102.34432,0 18.32417,83.536554 103.15283,168.36917 c -6.52233,17.80465 3.34909,43.08736 20.21314,51.76217 v 0 c 6.24325,4.26283 14.27194,6.29676 22.47262,6.29676 v 0 c 12.368,0 25.11827,-4.62604 32.66528,-13.17468"/>
  </svg>
  <svg class="box-logo box-logo-right" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 210 297">
    <defs>
      <!-- the theme's first colour, a touch lighter towards the box's middle -->
      <linearGradient [id]="'tsxLogoBottomLeft_' + p.key" x1="0" y1="1" x2="1" y2="0">
        <stop offset="0" style="stop-color: var(--plugin-primary, var(--theme-color))"/>
        <stop offset="1" style="stop-color: color-mix(in srgb, var(--plugin-primary, var(--theme-color)) 82%, #ffffff)"/>
      </linearGradient>
    </defs>
    <path [style.fill]="'url(#tsxLogoBottomLeft_' + p.key + ')'" d="M 31.496131,83.498219 C 17.281586,96.049685 13.920954,122.9803 24.61827,138.63631 v 0 c 8.67477,16.8641 33.95747,26.73174 51.762024,20.2132 v 0 l 54.361716,54.36558 -83.532627,83.53647 60.446297,8e-5 84.02015,-83.53655 -84.82866,-84.83262 C 113.3695,110.57782 103.49808,85.295107 86.634028,76.620298 v 0 C 80.390777,72.357466 72.362085,70.323536 64.161412,70.323536 v 0 c -12.368001,0 -25.118271,4.626039 -32.665281,13.174683"/>
  </svg>
  <div class="dts-copy">
    <!-- as the app boxes' left side (owner 2026-10-10: "Tidy Desktop kutusu gibi"): the platform on top
         where they name theirs, the theme's icon and name, its three tags in the lead's style, then
         its inspiration (no palette: owner 2026-10-10) -->
    <span class="dts-eyebrow tsx-eyebrow">
      <img class="dts-eyebrow-logo" *ngIf="platform?.logo" [src]="platform?.logo" alt="" width="18" height="18"/>{{ platform?.name }}
    </span>
    <!-- re-created per theme, so the fade replays on every change -->
    <ng-container *ngFor="let k of [ p.key ]">
      <h2 class="dts-title tsx-fade" [style.--tsx-chars]="title.length"><img class="dts-title-icon" [src]="p.logo" alt="" width="48" height="48"/>{{ title }}</h2>
    </ng-container>
    <p class="dts-lead tsx-tags">{{ ( p.tags || [] ).slice( 0, 3 ).join( ' · ' ) || ( active?.category + ' · ' + p.appearance ) }}</p>
    <p class="dts-text tsx-story">{{ story }}</p>
    <ul class="dts-facts">
      <li *ngIf="p.editorialLabel">{{ p.editorialLabel }}</li>
      <li>{{ statsLoaded ? ( downloads || 'N/A' ) : '...' }} Downloads</li>
      <li *ngIf="statsLoaded && rating && rating > 0">{{ rating | number: '1.1-1' }} Rating</li>
      <li>{{ platforms.length }} Platforms</li>
    </ul>
    <div class="dts-actions">
      <a class="codigrate-button" [routerLink]="themeUrl" [queryParams]="{ product: p.key, category: active?.category }"><p>Discover More</p></a>
      <!-- the chosen platform's own button (Add to cart, Go to store, Download now or Coming soon), under
           the theme's page (owner 2026-10-10: in place of All Themes), the price beside it -->
      <div class="tsx-buy">
      <button type="button" class="codigrate-button tsx-cta" [disabled]="planned" [class.disabled]="planned" (click)="cta.emit()">
        <!-- every label stacked, the current one visible: the button keeps the widest one's width; in a
             <p> like every site button's label, so it wears the same size -->
        <p class="tsx-cta-labels">
          <span class="tsx-cta-label" *ngFor="let label of ctaLabels" [class.current]="label === ctaText" [attr.aria-hidden]="label !== ctaText || null">{{ label }}</span>
        </p>
      </button>
      <!-- the price of a listing sold on the site, right beside its Add to cart (owner 2026-10-10), at
           the end of the row so nothing above or below it moves; a listing on another store (Go to
           store) or one the store cannot sell yet shows none -->
      <span class="tsx-offer" *ngIf="priceLabel && !planned">
        <span class="tsx-offer-amount">{{ priceLabel }}</span>
        <!-- a free listing is open source; a paid one is bought once -->
        <span class="tsx-offer-note">{{ isFree ? 'Open source' : 'One-time purchase' }}</span>
      </span>
      </div>
    </div>
  </div>

  <div class="dts-show">
    <div class="dts-head">
      <h3 class="dts-headline"><span class="dts-accent">{{ title }}</span> for {{ platform?.name }}</h3>
      <p class="dts-head-line tsx-head-line">{{ platformLine }}</p>
    </div>

    <!-- the theme on the chosen platform; the home swaps the picture once the next has loaded -->
    <div class="dts-stage">
      <div class="dts-scenes on" data-layout="one">
        <!-- re-created per picture, so the fade replays on every change -->
        <ng-container *ngFor="let src of [ screenshot?.src ]">
          <button type="button" class="dts-scene tsx-shot" *ngIf="src" (click)="enlarge()" [class.tsx-shot-framed]="platform?.name !== 'Line'"
                  [attr.aria-label]="'Enlarge: ' + title + ' for ' + platform?.name">
            <img class="tsx-fade" [src]="src" [alt]="title + ' for ' + platform?.name" decoding="async"/>
          </button>
        </ng-container>
      </div>
    </div>

    <!-- the platforms the theme is on, as logos; for one theme alone, centred in their own row under
         both sides, where the home has its themes' dock (owner 2026-10-15) -->
    <ng-container *ngIf="groups.length" [ngTemplateOutlet]="platformDock"></ng-container>
  </div>

  <div class="tsx-dock-row" *ngIf="!groups.length"><ng-container [ngTemplateOutlet]="platformDock"></ng-container></div>

  <!-- every theme as its icon (its name on hover) in one row under the box (owner 2026-10-10: the
       picker under the buttons made the left side too busy), the bundle first, then Nature, then
       Cities, a thin line between them; an icon picks its theme for the box; none for one theme
       alone (the themes page's expander) -->
  <div class="tsx-themes" *ngIf="groups.length">
    <span class="tsx-dock-label" aria-hidden="true">Themes</span>
    <div class="tsx-tray" #tray role="group" aria-label="Themes">
      <ng-container *ngFor="let g of groups; let first = first; trackBy: trackGroup">
        <span class="tsx-divider" *ngIf="!first" aria-hidden="true"></span>
        <div class="tsx-group" role="group" [attr.aria-label]="g.label + ' themes'">
          <button type="button" class="tsx-poster" *ngFor="let t of g.items; trackBy: trackTheme"
                  [attr.data-key]="t.product.key"
                  [class.on]="t.product.key === p.key" [attr.aria-pressed]="t.product.key === p.key"
                  [attr.aria-label]="titleOf( t.product )" [title]="titleOf( t.product )"
                  [style.--poster-primary]="t.product.designTokens?.primaryColor"
                  (click)="themePick.emit( t.product.key )">
            <img [src]="t.product.logo" alt="" width="36" height="36" loading="lazy" decoding="async" draggable="false"/>
          </button>
        </div>
      </ng-container>
    </div>
  </div>

  <!-- the reviews (owner 2026-10-11): the home projects app-review-showcase here, so they read as
       the foot of this box in its colours rather than a box of their own -->
  <div class="tsx-reviews"><ng-content select="[tsxReviews]"></ng-content></div>
</section>

<ng-template #platformDock>
  <div class="tsx-platform-row">
    <span class="tsx-dock-label" aria-hidden="true">Platforms</span>
    <div class="tsx-platforms" role="group" aria-label="Platforms">
      <ng-container *ngFor="let pl of platforms; let i = index; trackBy: trackPlatform">
      <!-- a line between the coverage table's groups (IDEs, editors, terminals, ...; owner 2026-10-15) -->
      <span class="tsx-divider tsx-platform-divider" *ngIf="i > 0 && pl.category && pl.category !== platforms[ i - 1 ].category" aria-hidden="true"></span>
      <button type="button" class="tsx-platform"
              [class.on]="i === platformIndex" [attr.aria-pressed]="i === platformIndex" [title]="pl.name" [attr.aria-label]="pl.name"
              (click)="platformPick.emit( i )">
        <img [src]="pl.logo" alt="" width="22" height="22"/>
      </button>
      </ng-container>
    </div>
  </div>
</ng-template>

<!-- Lightbox: the theme pages' (src/styles/page/tool-lightbox.scss), as in the other boxes; outside the
     section, whose isolation would keep it under the content after the box -->
<div class="cp-lightbox" *ngIf="lightbox" role="dialog" aria-modal="true" [attr.aria-label]="lightbox.name" (click)="closeLightbox()">
  <figure class="cp-lightbox-inner" (click)="$event.stopPropagation()">
    <img [src]="lightbox.large" [alt]="lightbox.alt">
  </figure>
  <img class="td-lb-preload" [src]="shotAt( -1 ).large" alt="">
  <img class="td-lb-preload" [src]="shotAt( 1 ).large" alt="">
  <div class="cp-lightbox-caption-row" (click)="$event.stopPropagation()">
    <button class="cp-lb-seg cp-lb-nav" type="button" (click)="stepLightbox( -1, $event )" aria-label="Previous picture">
      <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M15 4.5 L7.5 12 L15 19.5" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"></path></svg>
    </button>
    <span class="cp-lb-seg td-lb-label">
      <span class="cp-lb-name">
        <span class="cp-lb-name-sizer" *ngFor="let s of shots" aria-hidden="true">{{ s.name }}</span>
        <span class="cp-lb-name-cur">{{ lightbox.name }}</span>
      </span>
    </span>
    <button class="cp-lb-seg cp-lb-nav" type="button" (click)="stepLightbox( 1, $event )" aria-label="Next picture">
      <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 4.5 L16.5 12 L9 19.5" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"></path></svg>
    </button>
    <button class="cp-lb-seg cp-lb-close" type="button" (click)="closeLightbox()" aria-label="Close">&times;</button>
  </div>
</div>
